import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { getFirstLinkedAssetOrDefault } from '@r-and-a-shared-ui/common-kontent-client/utils';
import { getMappedLinkedItems } from './utils/component-mapping-helpers';

export const player_portals_footer = (entry: PLAYER_PORTALS_MODELS.Footer) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }
  const { elements, system } = entry;

  const mobileBackgroundImage = getFirstLinkedAssetOrDefault(
    elements?.mobile_background_image,
  );

  const desktopBackgroundImage = getFirstLinkedAssetOrDefault(
    elements?.desktop_background_image,
  );

  return {
    links: getMappedLinkedItems(elements?.links),
    copyrightNotice: elements?.copyright_notice.value,
    organizationLogos: getMappedLinkedItems(elements?.organization_logos),
    mobileBackgroundImage: mobileBackgroundImage?.url,
    desktopBackgroundImage: desktopBackgroundImage?.url,
    kontentItemId: system?.id,
  };
};

export default player_portals_footer;
